import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const HOA_DON_BAN_DICH_VU_COLUMNS: ExcelColumnMapping[] = [
  { header: 'Trạng thái', width: 12, resolver: row => row.status ?? '' },
  { header: 'Trạng thái HĐĐT', width: 16, resolver: row => row.ma_tthddt ?? '' },
  { header: 'Số c/từ', width: 18, resolver: row => row.so_ct ?? '' },
  { header: 'Số hóa đơn', width: 16, resolver: row => row.so_ct_hddt ?? '' },
  { header: 'Ngày c/từ', width: 14, resolver: row => formatDate(row.ngay_ct ?? '') },
  { header: 'Mã khách hàng', width: 18, resolver: row => row.ma_kh_data?.customer_code ?? '' },
  { header: 'Tên khách hàng', width: 28, resolver: row => row.ma_kh_data?.customer_name ?? '' },
  { header: 'Diễn giải', width: 30, resolver: row => row.dien_giai ?? '' },
  { header: 'Tk nợ', width: 12, resolver: row => row.tk_data?.code ?? '' },
  { header: 'Tổng tiền', width: 18, resolver: row => Number(row.t_tt_nt ?? 0) },
  { header: 'Ngoại tệ', width: 12, resolver: row => row.ma_nt_data?.ma_nt ?? '' }
];
